import React from 'react'
import { Alert } from 'antd'

const Message = ({ message }) => {
  return <Alert message={message} type="success" />
}

export default Message
